import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import StandardModal from "@/js/components/shared/StandardModal";
import { Button } from "@chakra-ui/react";

interface Props {
	open: boolean;
	classroomName: string;
	onDelete: () => void;
	onCancel: () => void;
}

export const DeleteClassConfirmModal: React.FC<Props> = ({ open, classroomName, onDelete, onCancel }) => {
	const { t } = useTranslation();
	return (
		<StandardModal
			title={t("deleteClass.title", { classroomName })}
			open={open}
			close={onCancel}
			actions={
				<Fragment>
					<Button variant="danger" float={"right"} onClick={onDelete}>
						{t("deleteClass.deleteButton")}
					</Button>
				</Fragment>
			}
			size="medium"
			contentClassName="DeleteClassConfirmModal_content"
		>
			{t("deleteClass.body")}
		</StandardModal>
	);
};
